import * as Types from './study-management-api.types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
import * as ApolloCore from '@apollo/client/core';
export type CreatePatientDiagnosisMutationVariables = Types.Exact<{
  input:
    | Array<Types.InputMaybe<Types.InputCreatePatientDiagnosis>>
    | Types.InputMaybe<Types.InputCreatePatientDiagnosis>;
}>;

export type CreatePatientDiagnosisMutation = {
  __typename?: 'Mutation';
  createPatientDiagnosis: Array<{
    __typename?: 'PatientDiagnosis';
    id: any;
    createdAt: any;
    updatedAt: any;
    userID: any;
    studyDiagClassificationID: any;
    diagDate: any;
  } | null>;
};

export type UpdatePatientDiagnosisMutationVariables = Types.Exact<{
  input: Types.InputUpdatePatientDiagnosis;
}>;

export type UpdatePatientDiagnosisMutation = {
  __typename?: 'Mutation';
  updatePatientDiagnosis: {
    __typename?: 'PatientDiagnosis';
    id: any;
    createdAt: any;
    updatedAt: any;
    userID: any;
    studyDiagClassificationID: any;
    diagDate: any;
  };
};

export type DeletePatientDiagnosisMutationVariables = Types.Exact<{
  input: Array<Types.InputMaybe<Types.Scalars['Int64']>> | Types.InputMaybe<Types.Scalars['Int64']>;
}>;

export type DeletePatientDiagnosisMutation = {
  __typename?: 'Mutation';
  deletePatientDiagnosis: Array<any | null>;
};

export type PatientDiagnosisQueryVariables = Types.Exact<{
  id: Types.Scalars['Int64'];
}>;

export type PatientDiagnosisQuery = {
  __typename?: 'Query';
  patientDiagnosis: {
    __typename?: 'PatientDiagnosis';
    id: any;
    createdAt: any;
    updatedAt: any;
    userID: any;
    studyDiagClassificationID: any;
    diagDate: any;
  };
};

export type PatientDiagnosesQueryVariables = Types.Exact<{
  queryParams: Types.InputQueryPatientDiagnosis;
}>;

export type PatientDiagnosesQuery = {
  __typename?: 'Query';
  patientDiagnoses: Array<{
    __typename?: 'PatientDiagnosis';
    id: any;
    createdAt: any;
    updatedAt: any;
    userID: any;
    studyDiagClassificationID: any;
    diagDate: any;
  } | null>;
};

export type DiagClassificationsQueryVariables = Types.Exact<{
  query: Types.InputQueryDiagClassification;
}>;

export type DiagClassificationsQuery = {
  __typename?: 'Query';
  diagClassifications: Array<{
    __typename?: 'DiagClassification';
    id: any;
    createdAt: any;
    updatedAt: any;
    conditionTitle: string;
    conditionCode: string;
  } | null>;
};

export type CreateDiagClassificationMutationVariables = Types.Exact<{
  input: Types.InputCreateDiagClassification;
}>;

export type CreateDiagClassificationMutation = {
  __typename?: 'Mutation';
  createDiagClassification: {
    __typename?: 'DiagClassification';
    id: any;
    createdAt: any;
    updatedAt: any;
    conditionTitle: string;
    conditionCode: string;
  };
};

export type StudyDiagClassificationsQueryVariables = Types.Exact<{
  queryParams: Types.InputQueryStudyDiagClassification;
}>;

export type StudyDiagClassificationsQuery = {
  __typename?: 'Query';
  studyDiagClassifications: Array<{
    __typename?: 'StudyDiagClassification';
    id: any;
    createdAt: any;
    updatedAt: any;
    studyID: any;
    diagClassificationID: any;
  } | null>;
};

export type CreateStudyDiagClassificationMutationVariables = Types.Exact<{
  input: Types.InputCreateStudyDiagClassification;
}>;

export type CreateStudyDiagClassificationMutation = {
  __typename?: 'Mutation';
  createStudyDiagClassification: {
    __typename?: 'StudyDiagClassification';
    id: any;
    createdAt: any;
    updatedAt: any;
    studyID: any;
    diagClassificationID: any;
  };
};

export type PatientSubjectQueryVariables = Types.Exact<{
  query: Types.InputQueryPatientSubject;
}>;

export type PatientSubjectQuery = {
  __typename?: 'Query';
  patientSubject: {
    __typename?: 'PatientSubject';
    id: any;
    createdAt: any;
    updatedAt: any;
    userID: any;
    siteReferenceID: string;
    subjectNumber: any;
    participantID: string;
    patientType?: string | null;
  };
};

export type AllDiagnosesForStudyAndUserQueryVariables = Types.Exact<{
  studyId: Types.Scalars['Int64'];
  userId: Types.Scalars['Int64'];
}>;

export type AllDiagnosesForStudyAndUserQuery = {
  __typename?: 'Query';
  diagClassifications: Array<{
    __typename?: 'DiagClassification';
    id: any;
    conditionCode: string;
    conditionTitle: string;
  } | null>;
  studyDiagClassifications: Array<{
    __typename?: 'StudyDiagClassification';
    id: any;
    studyID: any;
    diagClassificationID: any;
  } | null>;
  patientDiagnoses: Array<{
    __typename?: 'PatientDiagnosis';
    id: any;
    userID: any;
    studyDiagClassificationID: any;
    diagDate: any;
  } | null>;
};

export type CreatePatientStudyMutation = {
  __typename?: 'Mutation';
  CreatePatientStudy: {
    __typename?: 'CreatePatientStudy';
    dmSubjID: string;
    userStudyID: any;
    trial?: string | null;
    protocolViolation?: string | null;
    contractDt?: any | null;
    deathDt?: any | null;
    other?: string | null;
  };
};

export const CreatePatientDiagnosisDocument = /*#__PURE__*/ gql`
  mutation createPatientDiagnosis($input: [InputCreatePatientDiagnosis]!) {
    createPatientDiagnosis(input: $input) {
      id
      createdAt
      updatedAt
      userID
      studyDiagClassificationID
      diagDate
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreatePatientDiagnosisGQL extends Apollo.Mutation<
  CreatePatientDiagnosisMutation,
  CreatePatientDiagnosisMutationVariables
> {
  document = CreatePatientDiagnosisDocument;
  client = 'studyManagement';
  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdatePatientDiagnosisDocument = /*#__PURE__*/ gql`
  mutation updatePatientDiagnosis($input: InputUpdatePatientDiagnosis!) {
    updatePatientDiagnosis(input: $input) {
      id
      createdAt
      updatedAt
      userID
      studyDiagClassificationID
      diagDate
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdatePatientDiagnosisGQL extends Apollo.Mutation<
  UpdatePatientDiagnosisMutation,
  UpdatePatientDiagnosisMutationVariables
> {
  document = UpdatePatientDiagnosisDocument;
  client = 'studyManagement';
  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DeletePatientDiagnosisDocument = /*#__PURE__*/ gql`
  mutation deletePatientDiagnosis($input: [Int64]!) {
    deletePatientDiagnosis(input: $input)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class DeletePatientDiagnosisGQL extends Apollo.Mutation<
  DeletePatientDiagnosisMutation,
  DeletePatientDiagnosisMutationVariables
> {
  document = DeletePatientDiagnosisDocument;
  client = 'studyManagement';
  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const PatientDiagnosisDocument = /*#__PURE__*/ gql`
  query patientDiagnosis($id: Int64!) {
    patientDiagnosis(id: $id) {
      id
      createdAt
      updatedAt
      userID
      studyDiagClassificationID
      diagDate
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class PatientDiagnosisGQL extends Apollo.Query<
  PatientDiagnosisQuery,
  PatientDiagnosisQueryVariables
> {
  document = PatientDiagnosisDocument;
  client = 'studyManagement';
  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const PatientDiagnosesDocument = /*#__PURE__*/ gql`
  query patientDiagnoses($queryParams: InputQueryPatientDiagnosis!) {
    patientDiagnoses(queryParams: $queryParams) {
      id
      createdAt
      updatedAt
      userID
      studyDiagClassificationID
      diagDate
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class PatientDiagnosesGQL extends Apollo.Query<
  PatientDiagnosesQuery,
  PatientDiagnosesQueryVariables
> {
  document = PatientDiagnosesDocument;
  client = 'studyManagement';
  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DiagClassificationsDocument = /*#__PURE__*/ gql`
  query diagClassifications($query: InputQueryDiagClassification!) {
    diagClassifications(query: $query) {
      id
      createdAt
      updatedAt
      conditionTitle
      conditionCode
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class DiagClassificationsGQL extends Apollo.Query<
  DiagClassificationsQuery,
  DiagClassificationsQueryVariables
> {
  document = DiagClassificationsDocument;
  client = 'studyManagement';
  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateDiagClassificationDocument = /*#__PURE__*/ gql`
  mutation createDiagClassification($input: InputCreateDiagClassification!) {
    createDiagClassification(input: $input) {
      id
      createdAt
      updatedAt
      conditionTitle
      conditionCode
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateDiagClassificationGQL extends Apollo.Mutation<
  CreateDiagClassificationMutation,
  CreateDiagClassificationMutationVariables
> {
  document = CreateDiagClassificationDocument;
  client = 'studyManagement';
  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const StudyDiagClassificationsDocument = /*#__PURE__*/ gql`
  query studyDiagClassifications($queryParams: InputQueryStudyDiagClassification!) {
    studyDiagClassifications(queryParams: $queryParams) {
      id
      createdAt
      updatedAt
      studyID
      diagClassificationID
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class StudyDiagClassificationsGQL extends Apollo.Query<
  StudyDiagClassificationsQuery,
  StudyDiagClassificationsQueryVariables
> {
  document = StudyDiagClassificationsDocument;
  client = 'studyManagement';
  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateStudyDiagClassificationDocument = /*#__PURE__*/ gql`
  mutation createStudyDiagClassification($input: InputCreateStudyDiagClassification!) {
    createStudyDiagClassification(input: $input) {
      id
      createdAt
      updatedAt
      studyID
      diagClassificationID
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateStudyDiagClassificationGQL extends Apollo.Mutation<
  CreateStudyDiagClassificationMutation,
  CreateStudyDiagClassificationMutationVariables
> {
  document = CreateStudyDiagClassificationDocument;
  client = 'studyManagement';
  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const PatientSubjectDocument = /*#__PURE__*/ gql`
  query patientSubject($query: InputQueryPatientSubject!) {
    patientSubject(query: $query) {
      id
      createdAt
      updatedAt
      userID
      siteReferenceID
      subjectNumber
      participantID
      patientType
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class PatientSubjectGQL extends Apollo.Query<
  PatientSubjectQuery,
  PatientSubjectQueryVariables
> {
  document = PatientSubjectDocument;
  client = 'studyManagement';
  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const AllDiagnosesForStudyAndUserDocument = /*#__PURE__*/ gql`
  query allDiagnosesForStudyAndUser($studyId: Int64!, $userId: Int64!) {
    diagClassifications(query: {}) {
      id
      conditionCode
      conditionTitle
    }
    studyDiagClassifications(queryParams: { studyID: $studyId }) {
      id
      studyID
      diagClassificationID
    }
    patientDiagnoses(queryParams: { userID: $userId }) {
      id
      userID
      studyDiagClassificationID
      diagDate
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class AllDiagnosesForStudyAndUserGQL extends Apollo.Query<
  AllDiagnosesForStudyAndUserQuery,
  AllDiagnosesForStudyAndUserQueryVariables
> {
  document = AllDiagnosesForStudyAndUserDocument;
  client = 'studyManagement';
  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export const CreatePatientStudyDocument = /*#__PURE__*/ gql`
  mutation CreatePatientStudy($query: InputQueryCreatePatientStudy!) {
    CreatePatientStudy(query: $query) {
      dmSubjID
      userStudyID
      trial
      protocolViolation
      contractDt
      deathDt
      other
    }
  }
`;

type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

interface WatchQueryOptionsAlone<V>
  extends Omit<ApolloCore.WatchQueryOptions<V>, 'query' | 'variables'> {}

interface QueryOptionsAlone<V> extends Omit<ApolloCore.QueryOptions<V>, 'query' | 'variables'> {}

interface MutationOptionsAlone<T, V>
  extends Omit<ApolloCore.MutationOptions<T, V>, 'mutation' | 'variables'> {}

@Injectable({ providedIn: 'root' })
export class StudyManagementApiService {
  constructor(
    private createPatientDiagnosisGql: CreatePatientDiagnosisGQL,
    private updatePatientDiagnosisGql: UpdatePatientDiagnosisGQL,
    private deletePatientDiagnosisGql: DeletePatientDiagnosisGQL,
    private patientDiagnosisGql: PatientDiagnosisGQL,
    private patientDiagnosesGql: PatientDiagnosesGQL,
    private diagClassificationsGql: DiagClassificationsGQL,
    private createDiagClassificationGql: CreateDiagClassificationGQL,
    private studyDiagClassificationsGql: StudyDiagClassificationsGQL,
    private createStudyDiagClassificationGql: CreateStudyDiagClassificationGQL,
    private patientSubjectGql: PatientSubjectGQL,
    private allDiagnosesForStudyAndUserGql: AllDiagnosesForStudyAndUserGQL
  ) {}

  createPatientDiagnosis(
    variables: CreatePatientDiagnosisMutationVariables,
    options?: MutationOptionsAlone<
      CreatePatientDiagnosisMutation,
      CreatePatientDiagnosisMutationVariables
    >
  ) {
    return this.createPatientDiagnosisGql.mutate(variables, options);
  }

  updatePatientDiagnosis(
    variables: UpdatePatientDiagnosisMutationVariables,
    options?: MutationOptionsAlone<
      UpdatePatientDiagnosisMutation,
      UpdatePatientDiagnosisMutationVariables
    >
  ) {
    return this.updatePatientDiagnosisGql.mutate(variables, options);
  }

  deletePatientDiagnosis(
    variables: DeletePatientDiagnosisMutationVariables,
    options?: MutationOptionsAlone<
      DeletePatientDiagnosisMutation,
      DeletePatientDiagnosisMutationVariables
    >
  ) {
    return this.deletePatientDiagnosisGql.mutate(variables, options);
  }

  patientDiagnosis(
    variables: PatientDiagnosisQueryVariables,
    options?: QueryOptionsAlone<PatientDiagnosisQueryVariables>
  ) {
    return this.patientDiagnosisGql.fetch(variables, options);
  }

  patientDiagnosisWatch(
    variables: PatientDiagnosisQueryVariables,
    options?: WatchQueryOptionsAlone<PatientDiagnosisQueryVariables>
  ) {
    return this.patientDiagnosisGql.watch(variables, options);
  }

  patientDiagnoses(
    variables: PatientDiagnosesQueryVariables,
    options?: QueryOptionsAlone<PatientDiagnosesQueryVariables>
  ) {
    return this.patientDiagnosesGql.fetch(variables, options);
  }

  patientDiagnosesWatch(
    variables: PatientDiagnosesQueryVariables,
    options?: WatchQueryOptionsAlone<PatientDiagnosesQueryVariables>
  ) {
    return this.patientDiagnosesGql.watch(variables, options);
  }

  diagClassifications(
    variables: DiagClassificationsQueryVariables,
    options?: QueryOptionsAlone<DiagClassificationsQueryVariables>
  ) {
    return this.diagClassificationsGql.fetch(variables, options);
  }

  diagClassificationsWatch(
    variables: DiagClassificationsQueryVariables,
    options?: WatchQueryOptionsAlone<DiagClassificationsQueryVariables>
  ) {
    return this.diagClassificationsGql.watch(variables, options);
  }

  createDiagClassification(
    variables: CreateDiagClassificationMutationVariables,
    options?: MutationOptionsAlone<
      CreateDiagClassificationMutation,
      CreateDiagClassificationMutationVariables
    >
  ) {
    return this.createDiagClassificationGql.mutate(variables, options);
  }

  studyDiagClassifications(
    variables: StudyDiagClassificationsQueryVariables,
    options?: QueryOptionsAlone<StudyDiagClassificationsQueryVariables>
  ) {
    return this.studyDiagClassificationsGql.fetch(variables, options);
  }

  studyDiagClassificationsWatch(
    variables: StudyDiagClassificationsQueryVariables,
    options?: WatchQueryOptionsAlone<StudyDiagClassificationsQueryVariables>
  ) {
    return this.studyDiagClassificationsGql.watch(variables, options);
  }

  createStudyDiagClassification(
    variables: CreateStudyDiagClassificationMutationVariables,
    options?: MutationOptionsAlone<
      CreateStudyDiagClassificationMutation,
      CreateStudyDiagClassificationMutationVariables
    >
  ) {
    return this.createStudyDiagClassificationGql.mutate(variables, options);
  }

  patientSubject(
    variables: PatientSubjectQueryVariables,
    options?: QueryOptionsAlone<PatientSubjectQueryVariables>
  ) {
    return this.patientSubjectGql.fetch(variables, options);
  }

  patientSubjectWatch(
    variables: PatientSubjectQueryVariables,
    options?: WatchQueryOptionsAlone<PatientSubjectQueryVariables>
  ) {
    return this.patientSubjectGql.watch(variables, options);
  }

  allDiagnosesForStudyAndUser(
    variables: AllDiagnosesForStudyAndUserQueryVariables,
    options?: QueryOptionsAlone<AllDiagnosesForStudyAndUserQueryVariables>
  ) {
    return this.allDiagnosesForStudyAndUserGql.fetch(variables, options);
  }

  allDiagnosesForStudyAndUserWatch(
    variables: AllDiagnosesForStudyAndUserQueryVariables,
    options?: WatchQueryOptionsAlone<AllDiagnosesForStudyAndUserQueryVariables>
  ) {
    return this.allDiagnosesForStudyAndUserGql.watch(variables, options);
  }
}
